import { z } from "zod";

export const profileSchema = z.object({
  avatar: z.string().optional(),
  firstName: z.string().nonempty("First Name is required"),
  lastName: z.string().nonempty("Last Name is required"),
  phoneNumber: z.string().optional(),
  description: z.string().optional(),
  bio: z.string().optional(),
  availability_days: z.string().optional(),
  availability_hours: z.string().optional(),
});

export const notificationsSchema = z.object({
  email: z.boolean(),
  sms: z.boolean(),
  push: z.boolean(),
});

export const passwordSchema = z
  .object({
    newPassword: z
      .string()
      .min(8, "Password must be at least 8 characters")
      .refine(
        (val) =>
          /[0-9]/.test(val) && /[A-Z]/.test(val) && /[!@#$%^&*]/.test(val),
        "Password must include a number, an uppercase letter, and a special character"
      ),
    confirmNewPassword: z.string(),
  })
  .refine((data) => data.newPassword === data.confirmNewPassword, {
    message: "Passwords must match",
    path: ["confirmNewPassword"],
  });

export type ProfileFormValues = z.infer<typeof profileSchema>;
export type PasswordFormValues = z.infer<typeof passwordSchema>;
export type NotificationsFormValues = z.infer<typeof notificationsSchema>;
